import { useAnalyticsIdentity } from './use-analytics-identity';

/**
 * Держит идентичность Amplitude на всё время жизни приложения. Стоит в `src/App.tsx` внутри
 * `Provider` (хук читает стор) и над роутером: так пользователя видят и экраны вне шелла —
 * редакторы, выбор организатора, заглушка телефона. Ничего не рисует.
 */
export function AnalyticsIdentityTracker(): null {
  useAnalyticsIdentity();

  return null;
}
